import echarts from 'echarts'

import "@/utils/js/jquery1.0.js";
import "@/utils/js/shandong.js";
const install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart: {
      get() {
        return {
          progress: function (id, data) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            var optUseHad = {
              data: [{
                value: data.revenueTarget,
                name: '增效目标(万元)',
              },
              {
                value: data.actualCompletionProgress,
                name: '完成增效(万元)',

              },
              {
                value: data.revenueConfirm,
                name: '确认增效(万元)',

              },
              ],

            }
            var option = {
              grid: {
                height: '100%',
                // y:"30%",
                top: "40%"
              },
              tooltip: {
                show: true,
                formatter: "{b} <br> {c}件"

              },
              legend: {
                icon: 'rect',
                orient: 'horizontal',
                top: '47%',
                left: '10%',
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                  color: '#000',
                  rich: {
                    a: {
                      width: 90,
                      fontSize: 12,

                      height: 30,
                      color: '#dbd5d5',
                      // align: 'left',
                    },
                    b: {
                      width: 70,
                      fontSize: 16,
                      height: 25,
                      fontWeight: 'bold',
                      // align: 'left',
                    }
                  },
                },


                formatter: function (name) {
                  var target;
                  for (var j = 0, l = optUseHad.data.length; j < l; j++) {

                    if (optUseHad.data[j].name == name) {
                      target = optUseHad.data[j].value;

                    }
                  }
                  var arr = ['{a|' + name + '}'];
                  return arr.join('\n');
                },
              },
              toolbox: {
                show: true,
                top: 0,
                right: 0,
                feature: {
                  saveAsImage: {
                    title: '保存',
                    show: true,
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2

                  }

                }

              },
              xAxis: [{
                axisTick: {
                  show: false,

                },
                axisLine: {
                  show: false,
                },
                axisLabel: {
                  show: false

                },
                splitLine: {
                  show: false,

                }
              }],
              yAxis: [{
                type: 'category',
                data: [''],

                axisTick: {

                  show: false,
                },
                axisLine: {
                  //  color:'#fff',
                  show: false,
                },
                axisLabel: {
                  textStyle: {
                    color: '#fff',
                  }
                }

              }],
              series: [

                {
                  name: '增效目标(万元)',
                  type: 'bar',
                  bottom: '10%',
                  barWidth: 16,
                  zlevel: 1,
                  silent: true,
                  itemStyle: {
                    normal: {
                      color: '#feb924',
                      barBorderRadius: [10, 10, 10, 10],

                    }

                  },
                  barGap: '-100%',
                  barCategoryGap: '50%',
                  data: [{
                    value: data.revenueTarget,
                    itemStyle: {
                      normal: {
                        barBorderRadius: [10, 10, 10, 10],
                        color: "#feb924"
                      }
                    }
                  }],
                },
                {
                  name: '完成增效(万元)',
                  type: 'bar',
                  barWidth: 16,
                  zlevel: 3,
                  silent: true,
                  itemStyle: {
                    normal: {
                      color: '#fe7b35',
                      barBorderRadius: [10, 10, 10, 10],

                    }

                  },
                  barGap: '-100%',
                  barCategoryGap: '50%',

                  data: [{
                    value: data.actualCompletionProgress,
                    itemStyle: {
                      normal: {
                        barBorderRadius: [10, 10, 10, 10],
                        color: "#fe7b35"
                      }
                    }
                  }],
                },
                {
                  name: '确认增效(万元)',
                  type: 'bar',
                  barWidth: 16,
                  zlevel: 2,
                  silent: true,
                  itemStyle: {
                    normal: {
                      color: '#df4233',
                      barBorderRadius: [10, 10, 10, 10],

                    }

                  },
                  barGap: '-100%',
                  barCategoryGap: '50%',

                  data: [{
                    value: data.revenueConfirm,
                    itemStyle: {
                      normal: {
                        barBorderRadius: [10, 10, 10, 10],
                        color: "#df4233"
                      }
                    }
                  },],
                },
              ]
            };
            this.chart.setOption(option, true);
          },
          person: function (id, data) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            var personData = {
              data: [{
                value: data[0].formalNum,
                name: "合同制员工"
              },
              {
                value: data[0].informalNum,
                name: "外包员工"
              }
              ],
              totalValue: parseInt(data[0].formalNum) + parseInt(data[0].informalNum),
            }
            var option = {
              tooltip: {
                trigger: "item",
                formatter: "{b} : {d}% <br/> {c}"
              },
              toolbox: {
                show: true,
                top: 0,
                right: 0,
                feature: {
                  saveAsImage: {
                    title: '保存',
                    show: true,
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2

                  }

                }

              },
              legend: {
                icon: 'rect',
                orient: 'horizontal',
                x: "center",
                bottom: '10%',
                data: ["合同制员工", "外包员工"],
                itemWidth: 9,
                itemHeight: 9,
                textStyle: {
                  rich: {
                    a: {
                      width: 80,
                      fontSize: 12,
                      height: 30,
                      color: '#dbd5d5',
                      align: 'center',
                    },
                    b: {
                      width: 30,
                      fontWeight: 'bold',
                      align: 'center',
                      fontSize: 16,
                      color: '#333',
                    }


                  },

                },
                formatter: function (name) {
                  var oa = option.series[0].data;
                  var num = oa[0].value + oa[1].value;
                  for (var i = 0; i < option.series[0].data.length; i++) {
                    if (name == oa[i].name) {
                      var arr = ['{a|' + name + '}' + '\n' + ' {b|' + oa[i].value + '}'];

                    }
                  }
                  return arr.join('\n');
                },
              },
              title: {

                text: "总人数",
                subtext: personData.totalValue,
                x: "center",
                y: "25%",
                textStyle: {
                  fontSize: 14,
                  color: "#7777"
                },
                subtextStyle: {
                  fontSize: 24,
                  fontWeight: "bold",
                  align: "center",
                  color: "#333"
                }
              },
              series: [{
                type: "pie",
                radius: ["50%", "60%"],
                center: ["50%", "38%"],
                color: ["#feae21", "#ec802a"],
                itemStyle: {
                  normal: {
                    borderWidth: 0,
                    borderColor: "#fff"
                  }
                },
                data: personData.data,
                label: {
                  show: false
                }
              }]
            }
            this.chart.setOption(option, true);
          },
          map: function (id, mapData) {
            let myEcharts = echarts.init(document.getElementById(id));
            myEcharts.clear();
            let data = mapData.map(o => {
              return {
                name: o.groupName,
                value: (o.confirmRate * 100).toFixed(2)
              }
            })
            var toolTipData = mapData.map(o => {
              return {
                name: o.groupName,
                value: [{
                  name: "增效目标",
                  value: o.revenueTarget
                }, {
                  name: "确认增效",
                  value: o.revenueConfirm
                },
                {
                  name: "确认占比",
                  value: (o.confirmRate * 100).toFixed(2) + '%'
                }
                ]
              }
            })
            var option = {
              toolbox: {
                show: true,
                top: 0,
                right: 0,
                feature: {
                  saveAsImage: {
                    title: '保存',
                    show: true,
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2

                  }

                }

              },
              tooltip: {
                trigger: 'item',
                formatter: function (params) {
                  if (typeof (params.value)[2] == "undefined") {
                    var toolTiphtml = ''
                    for (var i = 0; i < toolTipData.length; i++) {
                      if (params.name == toolTipData[i].name) {
                        toolTiphtml += toolTipData[i].name + ':<br>'
                        for (var j = 0; j < toolTipData[i].value.length; j++) {
                          toolTiphtml += toolTipData[i].value[j].name + ':' + toolTipData[i].value[j].value + "<br>"
                        }
                      }
                    }


                    return toolTiphtml;
                  } else {
                    var toolTiphtml = ''
                    for (var i = 0; i < toolTipData.length; i++) {
                      if (params.name == toolTipData[i].name) {
                        toolTiphtml += toolTipData[i].name + ':<br>'
                        for (var j = 0; j < toolTipData[i].value.length; j++) {
                          toolTiphtml += toolTipData[i].value[j].name + ':' + toolTipData[i].value[j].value + "<br>"
                        }
                      }
                    }
                    return toolTiphtml;
                  }
                }
              },
              visualMap: {
                show: true,
                hoverLink: false,
                textStyle: { color: '#000' },
                x: 'left',
                y: 'bottom',
                pieces: [
                  { gte: 100 },
                  { gte: 80, lt: 100 },
                  { gte: 50, lt: 79 },
                  { gte: 30, lt: 49 },
                  { gte: 0, lt: 30 },
                ],
                color: ['#fde64a', '#de4233']
              },
              //   visualMap: {
              //     show: true,
              //     min: 0,
              //     max: 100,
              //     left: 'left',
              //     top: 'bottom',
              //     // text: ['高', '低'], // 文本，默认为数值文本
              //     calculable: true,
              //     seriesIndex: [1],
              //     inRange: {

              //         color: ['#fce64a', '#f8be21','#ec802a', '#df4233'] // 蓝绿


              //     }
              // },
              series: [{
                name: '山东',
                type: 'map',
                mapType: '山东',
                roam: false,
                top: '8%',
                zoom: 1.2,
                x: 'center',
                selectedMode: 'single', //multiple多选
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      textStyle: {
                        color: "#231816"
                      }
                    },
                    areaStyle: {
                      color: '#B1D0EC'
                    },
                    color: '#B1D0EC',
                    borderColor: '#a04600' //区块的边框颜色
                  },
                  emphasis: { //鼠标hover样式
                    label: {
                      show: true,
                      textStyle: {
                        color: 'rgba(255,255,255,.95)'
                      }
                    },
                    areaStyle: {
                      color: 'red'
                    }
                  }
                },
                data: data,
              }]
            };
            myEcharts.setOption(option);
            myEcharts.on("mouseover", function (params) {
              myEcharts.dispatchAction({
                type: 'downplay'
              });
            });
          },
          personRate: function (id, barData) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            let formalData = [];
            let informalData = [];
            let cityData = [];
            barData.forEach(element => {
              formalData.push(element.formalNum);
              informalData.push(element.informalNum);
              cityData.push(element.groupName);
            });
            // var data3 = [];
            // for (var i = 0; i < 17; i++) {
            //   var data = (formalData[i] + informalData[i]) / 2;
            //   data3[i] = data.toFixed(0);
            // }
            var option = {

              legend: {
                data: ['合同制人员', '外包人员'],
                textStyle: {
                  color: '#B5C9FF'
                },
                show: true,
                x: "center",
                top: '5%',
              },
              tooltip: {
                show: true,
                trigger: 'axis',
              },

              grid: {
                left: '4%',
                right: '3%',
                top: '19%',
                bottom: '1%',
                containLabel: true
              },
              toolbox: {
                "show": false,
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                axisTick: {
                  "show": false
                },
                minInterval: 30,
                axisLabel: {
                  textStyle: {
                    color: '#777777',
                    fontSize: '14',
                  },
                  interval: 0,
                  formatter: function (params) {
                    var newParamsName = ""; // 最终拼接成的字符串
                    var paramsNameNumber = params.length; // 实际标签的个数
                    var provideNumber = 6; // 每行能显示的字的个数
                    var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                    /**
                     * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                     */
                    // 条件等同于rowNumber>1
                    if (paramsNameNumber > provideNumber) {
                      /** 循环每一行,p表示行 */
                      for (var p = 0; p < rowNumber; p++) {
                        var tempStr = ""; // 表示每一次截取的字符串
                        var start = p * provideNumber; // 开始截取的位置
                        var end = start + provideNumber; // 结束截取的位置
                        // 此处特殊处理最后一行的索引值
                        if (p == rowNumber - 1) {
                          // 最后一次不换行
                          tempStr = params.substring(start, paramsNameNumber);
                        } else {
                          // 每一次拼接字符串并换行
                          tempStr = params.substring(start, end) + "\n";
                        }
                        newParamsName += tempStr; // 最终拼成的字符串
                      }

                    } else {
                      // 将旧标签的值赋给新标签
                      newParamsName = params;
                    }
                    //将最终的字符串返回
                    return newParamsName
                  }

                },
                axisLine: {
                  lineStyle: {
                    color: '#484d8d'
                  }
                },
                data: cityData
              },

              yAxis: [{
                name: '单位（人）',
                nameTextStyle: {
                  color: "#b7b7b7",
                  fontSize: 12,

                },
                color: '#B5C9FF',
                max: 200,
                min: 0,
                splitNumber: 10,
                splitLine: {
                  show: false
                },
                axisLabel: {
                  formatter: '{value}',
                  textStyle: {
                    color: '#c7c7c7',
                    fontSize: '14'
                  }
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: true
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: '#484d8d'
                  }
                },
                type: 'value'
              },
              {

                color: '#B5C9FF',
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  formatter: '{value}%',
                  textStyle: {
                    color: '#B5C9FF'
                  }
                },
                type: 'value'
              },

              ],
              series: [{
                name: '合同制人员',
                stack: "基金支出",
                type: "bar",
                barMaxWidth: 20,

                barCateGoryGap: "150%",
                itemStyle: {
                  normal: {
                    color: "#3a93f1",
                    label: {
                      show: true,
                      position: "inside",
                      textStyle: {
                        color: "#fff"
                      },

                    }
                  }
                },
                data: formalData,
              },
              {
                name: '外包人员',
                stack: "基金支出",
                type: "bar",
                barMaxWidth: 20,

                barCateGoryGap: "150%",

                itemStyle: {
                  normal: {
                    color: "#df4233",
                    label: {
                      show: true,
                      textStyle: {
                        color: "#fff"
                      },

                    }
                  }
                },
                data: informalData
              }
              ]
            };

            this.chart.setOption(option, true);
          },
          income: function (id, echartsData) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            let innerFontColor = '#f6f8fc';
            let outerFontColor = '#666666';
            let scale = 1;
            let echartData = {
              inner: [{
                value: echartsData.outConfirm,
                unit: '个',
                name: '外部增效'
              },
              {
                value: echartsData.costConfirm,

                name: '成本节约'
              },
              {
                value: echartsData.investConfirm,

                name: '投资节省'
              }
              ],
              outer: [{
                value: echartsData.outTarget,

                name: '外部增效'
              },
              {
                value: echartsData.costTarget,

                name: '成本节约'
              },
              {
                value: echartsData.investTarget,

                name: '投资节省'
              },

              ]
            }

            let legend1 = echartData.inner.map(v => v.name);
            let legend2 = echartData.outer.map(v => v.name);
            let legendData = [...legend1, ...legend2];

            var option = {
              backgroundColor: '#f6f8fc',
              color: ["#879cf7", "#ff7c34", "#feb824"],
              tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              toolbox: {
                show: true,
                top: '10',
                right: '10',
                feature: {
                  saveAsImage: {
                    title: '保存',
                    show: true,
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2

                  }

                }

              },
              series: [{
                name: '确认增效',
                type: 'pie',
                radius: [0, '35%'],
                center: ['50%', '55%'],
                itemStyle: {
                  normal: {
                    fontSize: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                  }
                },
                label: {
                  normal: {
                    position: 'inner',


                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                data: echartData.inner
              },
              {
                name: '项目储备',
                type: 'pie',
                radius: ['45%', '55%'],
                center: ['50%', '55%'],
                data: echartData.outer,
                labelLine: {
                  normal: {
                    length: 20,
                    length2: 140,
                    lineStyle: {
                      color: '#e6e6e6'
                    }
                  }
                },
                label: {
                  normal: {
                    formatter: params => {
                      return (
                        '{icon|项目储备}\n{name|' + params.name + '}{percent|' + params.value + '}{value|' +
                        (params.percent.toFixed(1) + '%') + '}'
                      );
                    },
                    padding: [0, -130, 25, -130],
                    rich: {
                      color: '#333',
                      borderWidth: 2,

                      icon: {
                        fontSize: 12,
                        color: "#777",
                        height: 30,
                        width: 80,
                        align: 'center',


                      },
                      name: {
                        fontSize: 12,
                        padding: [0, 5, 0, 5],
                        color: '#000'
                      },
                      percent: {
                        color: '#000',
                        padding: [0, 5, 0, 0],
                      },
                      value: {
                        fontSize: 12,
                        padding: 4,
                        color: '#fff',
                        backgroundColor: '#da2d2d',

                        borderRadius: 5,
                      }
                    }
                  }
                },
              }
              ]
            };
            this.chart.setOption(option, true);

          },
          everySix: function (id, data) {
            let _that = this;
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            var placeHolderStyle = {
              normal: {
                color: '#f3f3f3',
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              },
              emphasis: {
                color: '#393d50'
              }
            };
            var option = {
              title: {
                text: '',
                x: 'center',
                y: 'center',
                textStyle: {
                  fontWeight: 'normal',
                  fontSize: 24,
                  color: "#fff",
                }
              },
              grid: {
                height: '100%',

              },
              toolbox: {
                show: true,
                top: "-5",
                left: "20%",
                feature: {

                  saveAsImage: {
                    title: '保存',
                    show: true,
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2
                  },
                  // myTool1: {
                  //   show: true,
                  //     title: '数据导出',
                  //     icon: 'path://M886.624 128v192h-63.232V192H191.264v640h632.192l-0.032-128h63.232v192H128V128h758.624z m-116.672 256L928 512l-158.048 128v-96H359.008v-64h410.944v-96z',
                  //     onclick: function (){
                  //       _that.boardExport('ICT')
                  //     }
                  // },
                }
              },
              series: [{
                name: 'Line 1',
                type: 'pie',
                clockWise: false,
                radius: ["60%", "70%"],
                center: ['50%', '60%'],
                hoverAnimation: false,
                startAngle: 90,
                data: [
                  {
                    value: data.revenueTarget,
                    name: '增效目标',
                    itemStyle: {
                      normal: {
                        color: "#3a93f1"
                      }
                    },
                    label: {
                      normal: {
                        formatter: params => {
                          return (
                            '{icon|●}{name|' + params.name + '}'
                          );
                        },
                        padding: [0, 10, 1, 0],
                        rich: {
                          color: '#333',
                          icon: {
                            fontSize: 16
                          },
                          name: {
                            fontSize: 14,
                            padding: [0, 0, 0, 5],
                            color: '#666666'
                          },
                        }
                      }
                    },
                    labelLine: {
                      normal: {
                        length: -3,
                        length2: 50,
                        lineStyle: {
                          color: '#ccc'
                        }
                      }
                    },

                  },

                ]
              },
              {
                name: 'LINE 2',
                type: 'pie',
                clockWise: false,
                radius: ["40%", "50%"],
                center: ['50%', '60%'],
                hoverAnimation: false,
                startAngle: 90,

                data: [
                  {
                    value: data.actualCompletionProgress,
                    name: '完成增效',
                    itemStyle: {
                      normal: {
                        color: '#88bdf5'
                      }
                    },
                    label: {

                      normal: {
                        formatter: params => {
                          return (
                            '{icon|●}{name|' + params.name + '}'
                          );
                        },
                        padding: [0, 20, 5, 0],
                        rich: {
                          color: '#333',
                          icon: {
                            fontSize: 16
                          },
                          name: {
                            fontSize: 14,
                            padding: [0, 5, 0, 5],
                            color: '#666666'
                          },
                        }
                      }
                    },
                    labelLine: {
                      normal: {
                        length: 20,
                        length2: 20,
                        lineStyle: {
                          color: '#ccc'
                        }
                      }
                    },
                  },
                  {
                    value: data.revenueTarget - data.actualCompletionProgress,
                    name: '',
                    tooltip: {
                      show: false
                    },
                    label: {
                      normal: {
                        show: false,
                      }

                    },
                    labelLine: {
                      normal: {
                        length: 0,
                        length2: 0,
                      }
                    },

                    itemStyle: placeHolderStyle
                  },
                ]
              },
              {
                name: 'line 3',
                type: 'pie',
                clockWise: false,
                radius: ["20%", "30%"],
                center: ['50%', '60%'],
                hoverAnimation: false,
                startAngle: 90,

                data: [
                  {
                    value: data.revenueConfirm,
                    name: '确认增效',
                    itemStyle: {
                      normal: {
                        color: "#df4233"
                      }
                    },
                    label: {

                      normal: {
                        formatter: params => {
                          return (
                            '{icon|●}{name|' + params.name + '}'
                          );
                        },
                        padding: [0, 10, 0, 0],
                        rich: {
                          color: '#333',
                          icon: {
                            fontSize: 16
                          },
                          name: {
                            fontSize: 14,
                            padding: [0, 0, 0, 5],
                            color: '#666666'
                          },
                        }
                      }
                    },
                    labelLine: {
                      normal: {
                        length: 20,
                        length2: 40,
                        lineStyle: {
                          color: '#ccc'
                        }
                      }
                    },
                  },
                  {
                    value: data.revenueTarget - data.revenueConfirm,
                    name: '',
                    tooltip: {
                      show: false
                    },
                    label: {
                      normal: {
                        show: false,
                      }

                    },
                    labelLine: {
                      normal: {
                        length: 0,
                        length2: 0,
                      }
                    },
                    itemStyle: placeHolderStyle
                  },
                ]
              }
              ]
            };
            this.chart.setOption(option, true);

          },
          firstTotal: function (id, data, titleText) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            let category = [];
            let confirmList = []; //已完成
            let targetlist = []; //目标
            let rateList = []; // 完成率
            data.forEach(o => {
              category.push(o.groupName);
              confirmList.push(o.actualCompletionProgress);
              targetlist.push(o.revenueTarget);
              rateList.push((o.completionRate * 100).toFixed(2));
            })
            let averageRate = [];
            let sum = 0;
            for (let i = 0; i < rateList.length; i++) {
              sum += parseFloat(rateList[i]);
            }
            for (let i = 0; i < rateList.length; i++) {
              averageRate.push((sum / rateList.length).toFixed(2));
            }

            // option
            var option = {
              title: {
                text: titleText,
                x: 10,
                y: 10,
                textStyle: {
                  color: '#484848',
                  fontSize: 14,
                  fontWeight: 'bold',
                },

              },
              tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(0,0,0,.5)',
                axisPointer: {
                  type: 'shadow',
                  label: {
                    show: true,
                    backgroundColor: '#7B7DDC'
                  }
                },
                formatter: function (params) {
                  let htmlStr = '<div>';
                  htmlStr += params[0].name + '<br/>';
                  htmlStr += params[0].seriesName + '：' + params[0].value + '<br/>';
                  htmlStr += params[1].seriesName + '：' + params[1].value + '<br/>';
                  htmlStr += params[2].seriesName + '：' + params[2].value + '%' + '<br/>';
                  htmlStr += params[3].seriesName + '：' + params[3].value + '%' + '<br/>';
                  return htmlStr;
                }
              },
              toolbox: {
                show: true,
                top: 0,
                right: 30,
                feature: {
                  saveAsImage: {
                    title: "保存",
                    show: true,
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2

                  }

                }

              },
              legend: {
                data: ['预计增效(万元)', '完成增效(万元)', '完成进度',],
                textStyle: {
                  color: '#000'
                },
                bottom: '2%',
              },
              grid: {
                x: '12%',
                width: '82%',
                y: '25%',
              },
              xAxis: {
                data: category,
                axisLine: {
                  lineStyle: {
                    color: '#B4B4B4'
                  }
                },
                axisTick: {
                  show: false,
                },
                axisLabel: {
                  interval: 0,
                  // rotate:40
                  formatter: function (params) {
                    var newParamsName = ""; // 最终拼接成的字符串
                    var paramsNameNumber = params.length; // 实际标签的个数
                    var provideNumber = 6; // 每行能显示的字的个数
                    var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                    /**
                     * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                     */
                    // 条件等同于rowNumber>1
                    if (paramsNameNumber > provideNumber) {
                      /** 循环每一行,p表示行 */
                      for (var p = 0; p < rowNumber; p++) {
                        var tempStr = ""; // 表示每一次截取的字符串
                        var start = p * provideNumber; // 开始截取的位置
                        var end = start + provideNumber; // 结束截取的位置
                        // 此处特殊处理最后一行的索引值
                        if (p == rowNumber - 1) {
                          // 最后一次不换行
                          tempStr = params.substring(start, paramsNameNumber);
                        } else {
                          // 每一次拼接字符串并换行
                          tempStr = params.substring(start, end) + "\n";
                        }
                        newParamsName += tempStr; // 最终拼成的字符串
                      }

                    } else {
                      // 将旧标签的值赋给新标签
                      newParamsName = params;
                    }
                    //将最终的字符串返回
                    return newParamsName
                  }
                }
              },
              yAxis: [{

                splitLine: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#B4B4B4',
                  }
                },

                axisLabel: {
                  formatter: '{value} ',
                }
              },
              {
                min: 0,
                max: 100,
                splitLine: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#B4B4B4',
                  }
                },
                axisLabel: {
                  formatter: '{value}%',
                }
              }
              ],

              series: [

                {
                  name: '预计增效(万元)',
                  type: 'bar',
                  barGap: 0,
                  barWidth: 10,
                  itemStyle: {
                    normal: {
                      color: '#7c90f7',
                    }
                  },
                  data: targetlist
                },
                {
                  name: '完成增效(万元)',
                  type: 'bar',
                  barWidth: 10,
                  itemStyle: {
                    normal: {
                      color: '#ff8202',
                    }
                  },
                  data: confirmList
                },
                {
                  name: '完成进度',
                  type: 'line',
                  symbolSize: 0,
                  yAxisIndex: 1,
                  itemStyle: {
                    normal: {
                      color: '#f74434'
                    },
                  },
                  data: rateList
                },
                {
                  name: '平均完成进度',
                  type: 'line',
                  symbolSize: 0,
                  yAxisIndex: 1,
                  itemStyle: {
                    normal: {
                      color: '#98cefc'
                    },
                  },
                  data: averageRate
                },

              ]
            };
            this.chart.setOption(option, true);

          },
          rateDetail: function (id, data) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            var legendData = ["新闻摘要", "培训专题", "经验分享"]
            var colorList = ['#E9745F', '#F9B600', '#819EE3'];
            var option = {
              tooltip: {
                trigger: 'item',
                borderColor: 'rgba(255,255,255,.3)',
                backgroundColor: 'rgba(13,5,30,.6)',
                borderWidth: 1,
                padding: 5,
                formatter: function (parms) {
                  var str =
                    parms.name + '  ' + parms.percent + "%";
                  return str;
                }
              },
              legend: {
                type: "scroll",
                left: 'center',
                itemWidth: 12,
                itemHeight: 12,
                align: 'auto',
                top: 'bottom',
                textStyle: {
                  color: '#4F4F4F'
                },
                data: legendData
              },
              grid: {
                width: 'auto',
                height: 'auto'
              },
              series: [{
                type: 'pie',
                center: ['50%', '44%'],
                radius: ['40%', '55%'],
                clockwise: true,
                avoidLabelOverlap: true,
                hoverOffset: 15,
                itemStyle: {
                  normal: {
                    color: function (params) {
                      return colorList[params.dataIndex]
                    }
                  }
                },
                label: {        //展示文本设置 
                  normal: {
                    show: true,     //展示
                    position: 'outside',    // outside表示文本显示位置为外部
                    formatter: '{b} : {c}',
                  },
                  emphasis: {    //文本样式
                    show: true,    //展示
                    textStyle: {    //文本样式
                      fontSize: '14',
                      fontWeight: '600',
                    }
                  }
                },
                labelLine: {    //引导线设置
                  normal: {
                    show: true,   //引导线显示
                  }
                },

                data: data
              }]
            };
            this.chart.setOption(option, true);

          },
          barGrade: function (id, data) {
            this.chart = echarts.init(document.getElementById(id));
            this.chart.clear();
            var option = {
              dataset: {
                source: data,
              },
              legend: {
                textStyle: {
                  width: '50%',
                },
              },
              grid: { containLabel: true },
              yAxis: {},
              xAxis: {
                type: 'category',
                axisLabel: {
                  interval: 0,
                  formatter: function (value) {
                    var str = "";
                    var num = 3; //每行显示字数 
                    var valLength = value.length; //该项x轴字数  
                    var rowNum = Math.ceil(valLength / num); // 行数  
                    if (rowNum > 1) {
                      for (var i = 0; i < rowNum; i++) {
                        var temp = "";
                        var start = i * num;
                        var end = start + num;
                        temp = value.substring(start, end) + "\n";
                        str += temp;
                      }
                      return str;
                    } else {
                      return value;
                    }
                  }
                }
              },
              barMaxWidth: 10,
              series: [
                {
                  type: 'bar',
                  encode: {
                    y: 'score',
                    x: 'product'
                  },
                  itemStyle: {        //上方显示数值
                    normal: {
                      label: {
                        show: true, //开启显示
                        position: 'top', //在上方显示
                        textStyle: { //数值样式
                          color: 'black',
                          fontSize: 10
                        }
                      },
                      color: '#819EE3',  //设置所有柱状图颜色
                    }
                  }
                }
              ]
            };
            this.chart.setOption(option, true);
          }
        }
      }
    }
  })
}

export default {
  install,
}
